import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import type { ColDef } from "ag-grid-enterprise";
import moment from "moment";

export const useTableData = () => {
  const columns: ColDef[] = [
    {
      field: "Start",
      headerName: "Date",
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.Start, "MM/dd") || "",
      minWidth: 80,
      maxWidth: 100,
      flex: 1,
    },
    {
      field: "Shift",
      headerName: "Shift",
      valueGetter: (params) => params.data?.Shift || "",
      minWidth: 60,
      maxWidth: 60,
      flex: 1,
    },
    {
      field: "Crew",
      headerName: "Crew",
      valueGetter: (params) => params.data?.Crew || "",
      minWidth: 60,
      maxWidth: 60,
      flex: 1,
    },
    {
      field: "Start",
      headerName: "Start",
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.Start, "HH:mm:ss") || "",
      minWidth: 80,
      maxWidth: 100,
      flex: 1,
    },
    {
      field: "End",
      headerName: "End",
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.End, "HH:mm:ss") || "",
      minWidth: 80,
      maxWidth: 100,
      flex: 1,
    },
    {
      field: "Duration",
      headerName: "Duration",
      valueFormatter: (params) => {
        if (params.value) {
          const duration = moment.duration(params.value, "seconds");
          const minutes = Math.floor(duration.asMinutes());
          const seconds = duration.seconds();
          return `${minutes}m ${seconds}s`;
        }
        return "";
      },
      minWidth: 80,
      maxWidth: 120,
      flex: 1,
    },
    {
      field: "DelayCodeName",
      headerName: "Code",
      minWidth: 200,
      editable: false,
      flex: 1,
    },
    {
      field: "DelayCategoryName",
      headerName: "Category",
      maxWidth: 150,
      editable: false,
      flex: 1,
    },
    {
      field: "Comments",
      headerName: "Comments",
      minWidth: 120,
      flex: 3,
    },
    {
      field: "JustifiedByUser",
      headerName: "User",
      maxWidth: 100,
      minWidth: 100,
      editable: false,
      flex: 1,
    },
    {
      field: "JustifiedDatetime",
      headerName: "Justification",
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.JustifiedDatetime, "HH:mm:ss") || "",
      maxWidth: 150,
      minWidth: 100,
      flex: 1,
    },
  ];

  return { columns };
};
